import { Image } from 'native-base'
import React from 'react'

import { DESIGN_SYSTEM_THEME } from '../../../constants/config'

export const LoginImage: React.FC = () => {
  const path = () => {
    switch (DESIGN_SYSTEM_THEME) {
      case 'prosperia':
        return require('./login_prosperia.png')
      default:
        return require('./login_prosperia.png')
    }
  }

  return <Image source={path()} alt="" width="180" height="180" accessibilityIgnoresInvertColors={false} />
}
